module.exports = require('es6-promise').Promise;



//////////////////
// WEBPACK FOOTER
// ./~/es6-promise-promise/index.js
// module id = 38
// module chunks = 1